import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import "rc-time-picker/assets/index.css";
import { Modal, ModalBody } from "reactstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../OfficePolicyManagement.module.scss";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import Loader from "components/Loader";
import {
  useDefaultPolicies,
  useAddPolicyFolderByDefaultMutation,
} from "repositories/office-policy-management-repository";
import toast from "react-hot-toast";
import { useQueryClient } from "react-query";
function QuickPolicyModal({
  t,
  issaveEmployeeModalOpen,
  setIsSaveEmployeeModalOpen,
  refetch,
}) {
  const { effectiveOwnerId } = useAccountOwnerCommon();
  const [selectedPolicies, setSelectedPolicies] = useState([]);

  const {
    data: defaultPoliciesData,
    isLoading,
  } = useDefaultPolicies(effectiveOwnerId, {
    enabled: !!effectiveOwnerId && issaveEmployeeModalOpen,
  });

  const addPolicyMutation = useAddPolicyFolderByDefaultMutation();


  // Filter policies based on search and filters
  const officePoliciesData = useMemo(() => {
    return defaultPoliciesData||[];
  }, [
    defaultPoliciesData,
  ]);

  const checkPolicySelected = (selectedPolicy,policy) => {
    return selectedPolicy.defaultPolicyCategoryId === policy.defaultPolicyCategoryId&&selectedPolicy.id===policy.id;
  };

  const checkMember = (e, policy) => {
    if (e.target.checked) {
      setSelectedPolicies([...selectedPolicies, policy]);
    } else {
      setSelectedPolicies(
        selectedPolicies.filter((res) => !(checkPolicySelected(res,policy))),
      );
    }
  };

  const checkMemberRoleAvaliable = (array, value) => {
    return array.some((e) => checkPolicySelected(e,value));
  };

  const toggleSelectAll = (e) => {
    if (e.target.checked && officePoliciesData.length > 0) {
      setSelectedPolicies(officePoliciesData.flatMap((item)=>item.defaultPolicyFolders));
    } else {
      setSelectedPolicies([]);
    }
  };
const queryclient = useQueryClient();
  const handleAddPolicies = async () => {
    if (!selectedPolicies || selectedPolicies.length === 0) {
      toast.error(
        t("officePolicyManagement.selectAtLeastOnePolicy") 
      );
      return;
    }

    try {
      const items = selectedPolicies.map((policy) => ({
        DefaultPolicyCategoryId:
          policy.defaultPolicyCategoryId,
        DefaultPolicyFolderId:
          policy.id,
      }));

      await addPolicyMutation.mutateAsync({
        OwnerId: effectiveOwnerId,
        Items: items,
      });
      queryclient.invalidateQueries({
        queryKey: ["/officePolicies/policyFolderList"],
      });
      toast.success(
        t("officePolicyManagement.policiesAddedSuccessfully") 
      );
      if(refetch){
        refetch();
      }
      setIsSaveEmployeeModalOpen(false);
    } catch (error) {
      toast.error(
        error?.message ||
          t("officePolicyManagement.failedToAddPolicies") 
      );
    }
  };

  // Reset selected policies when modal opens/closes
  useEffect(() => {
    if (issaveEmployeeModalOpen) {
      setSelectedPolicies([]);
    }
  }, [issaveEmployeeModalOpen]);

  return (
    <Modal
      isOpen={issaveEmployeeModalOpen}
      toggle={() => setIsSaveEmployeeModalOpen(false)}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={() => setIsSaveEmployeeModalOpen(false)}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody className={styles["add-employee-modal-dialog"]}>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          <span className="modal-title-25">
            {t("officePolicyManagement.selectPolicy")}
          </span>
        </Text>

        <Text className={` ${styles["policy-modal-text"]} `}>
          {selectedPolicies?.length} {t("accountOwner.selected")}
        </Text>
{addPolicyMutation.isLoading && <Loader />}
        <div className="ch-checkbox">
          <label>
            <input
              type="checkbox"
              checked={
              selectedPolicies.length > 0 &&
                officePoliciesData.every((policy) =>
                  policy.defaultPolicyFolders.every((internalPolicy)=>selectedPolicies.some(
                    (selected) => checkPolicySelected(selected,internalPolicy),
                  )),
                )
              }
              onChange={toggleSelectAll}
            />
            <span> {t("staffTimesheet.selectAll")}</span>
          </label>
        </div>
        {false && <Loader />}
        {officePoliciesData.length > 0 && <Accordion
          className={["add-role-accordion contract-detail-accordion"]}
          preExpanded={[officePoliciesData[0]?.id||0]}
          allowZeroExpanded={true}
        >
         {officePoliciesData.map((item)=>item.defaultPolicyFolders.length===0?null:<AccordionItem uuid={item.id} key={item.id}>
                <AccordionItemHeading>
                  <AccordionItemButton>{item.name}</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <ul className={"modal-employee-list " + styles["employee-list-box"]+" "+styles["quicky-policy-listing"]}>
                    {item.defaultPolicyFolders.map((policy)=><li key={policy.id}>
                  <div className="ch-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        checked={checkMemberRoleAvaliable(
                          selectedPolicies,
                          policy,
                        )}
                        onChange={(e) => checkMember(e, policy)}
                      />
                      <span className={` ${styles["employee-list-wrapper"]} `}>
                        {policy.name}
                      </span>
                    </label>
                  </div>
                </li>)}
                  </ul>
                </AccordionItemPanel>
                </AccordionItem>)}
                </Accordion>}
          {officePoliciesData.length === 0 && (
            <ul className={"modal-employee-list " + styles["employee-list-box"]}>
        
            <li>
              <div className="ch-checkbox">
                <label>{t("officePolicyManagement.noPoliciesFound")}</label>
              </div>
            </li>
            </ul>
          )}
        {isLoading && <Loader />}
        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100"
          title={t("accountOwner.addEmployees")}
          onClick={handleAddPolicies}
          disabled={addPolicyMutation.isLoading || isLoading}
        >
          {t("officePolicyManagement.select")}
        </button>
        <button
          className="button button-round button-border btn-mobile-link button-dark mb-md-3"
          onClick={() => setIsSaveEmployeeModalOpen(false)}
          title={t("cancel")}
        >
          {t("cancel")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(QuickPolicyModal);
